// extracted by mini-css-extract-plugin
module.exports = {"root":"avatar-module--root--3fXE9"};